import React, { Component } from 'react';
import './styles/App.css';
import Routes from './routes';
import AuthStore from './stores/auth-store.js';
import dispatcher from './dispatcher';


class App extends Component {

	constructor() {
		super();
		this.state = {
			authProps: AuthStore.getAuthenticationData()
		};
		this.updateAuthState = this.updateAuthState.bind(this);
	}

	componentDidMount() {
		AuthStore.on('change', this.updateAuthState);
		dispatcher.dispatch({
			type: 'get_current_session'
		})
	}

	updateAuthState() {
		this.setState({
			authProps: AuthStore.getAuthenticationData()
		});
	}

	componentWillUnmount() {
		AuthStore.removeListener('change', this.getFields);
	}

	render() {
		if(this.state.authProps.isAuthenticating)
			return null;
		return (
			<div className="App">
			<Routes authProps={this.state.authProps}/>
			</div>
			);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js